import { useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import styles from './PasswordHide.module.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';

export const CustomInput = ({
  callback,
  placeholder,
  value,
  borderDesign = 'linear-gradient(160deg, rgba(103,95,163,1) 10%, rgba(39,49,58,1) 40%, rgba(19,30,43,1) 50%,rgba(39,49,58,1) 60%, rgba(103,95,163,1) 90%)',
  height = 50,
  width = 350,
  borderSize = 2,
  borderRadius = 20,
  inputBackground = '#111D2B',
  type = 'text',
  rows = 4,
  textarea = false,
  password = false,
  maxLength = 1000,
  readonly = false,
  autoComplete,
}) => {
  // const [readOnlyState, setReadOnlyState] = useState(readonly)
  const [reveal, setReveal] = useState(false);

  return (
    <div
      className="w-100"
      style={{
        background: borderDesign,
        padding: borderSize,
        borderRadius,
      }}
    >
      <div
        className="w-100"
        style={{
          background: inputBackground,
          borderRadius,
          overflow: 'hidden',
        }}
      >
        {textarea ? (
          <Form.Control
            as="textarea"
            rows={rows}
            value={value ?? ''}
            onChange={(e) => callback(e.target.value)}
            placeholder={placeholder}
            maxLength={maxLength}
            readOnly={readonly}
            className="p-3"
            style={{
              background: 'transparent',
              border: 'none',
              color: 'var(--color-font)',
              resize: 'vertical',
              overflowX: 'hidden',
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word',
              minHeight: rows ? rows * 22 + 24 : undefined, // comfy default
            }}
            wrap="soft"
          />
        ) : (
          <InputGroup className="align-items-center">
            <Form.Control
              value={value ?? ''}
              onChange={(e) => callback(e.target.value)}
              placeholder={placeholder}
              readOnly={readonly}
              type={type === 'password' ? (reveal ? 'text' : 'password') : type}
              autoComplete={autoComplete}
              className={type === 'password' ? styles.passwordHide : ''}
              style={{
                paddingLeft: 15,
                height: height - borderSize * 2,
                background: 'transparent',
                border: 'none',
                color: 'var(--color-font)',
              }}
            />
            {type === 'password' && (
              <Button
                variant="link"
                className="text-decoration-none me-2"
                onClick={() => setReveal(!reveal)}
                style={{ color: 'var(--color-font)' }}
              >
                {reveal ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
              </Button>
            )}
          </InputGroup>
        )}
      </div>
    </div>
  );
};
